import { LinkOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { ListUnsubscribe } from 'ui/icons';
import { useTranslation } from 'modules/domains/list';
import { createEmailListIdParams } from '../../../utils';
import { LIST_UNSUBSCRIBE_URL } from '../../../constants';
import { List } from '../../../types';

export const useRemoveUsersLink = (list: List): LinkOption => {
  const { t } = useTranslation();
  const href = createEmailListIdParams(list, LIST_UNSUBSCRIBE_URL);

  return {
    as: AllowedActionMenuElements.Link,
    href,
    content: (
      <>
        <ListUnsubscribe height={16} width={16} />
        <span>{t('indexPage.table.overflowMenu.unsubscribe')}</span>
      </>
    ),
    id: 'list-unsubscribe-link',
  };
};
